import { toTitleCase } from '@/lib/utils'
import { Trash } from 'lucide-react'
import { DropdownMenuItem } from '../ui/dropdown-menu'
import ActionWithConfirmation from './ActionWithConfirmation'

const DeleteActionWithConfirmation = ({ model = '', ...props }) => {
  const title = model ? `Delete ${toTitleCase(model)}` : 'Delete'
  const description = model
    ? `Are you sure you want to delete this ${model}? This action cannot be undone.`
    : 'Are you sure you want to delete? This action cannot be undone.'
  return (
    <ActionWithConfirmation
      trigger={
        <DropdownMenuItem
          variant="destructive"
          // The dropdown menu closing will also close the dialog
          // This will prevent that from happening
          onSelect={(e) => e.preventDefault()}
        >
          <Trash className="text-inherit" />
          Delete
        </DropdownMenuItem>
      }
      title={title}
      pendingText="Deleting..."
      description={description}
      variant="destructive"
      {...props}
    />
  )
}

export default DeleteActionWithConfirmation
